// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const {
  setInitialised,
  addWheelControls,
  autoPlay,
} = window.BAO.Carousel.plugins
class HoverCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els?.slide?.elements?.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    if (this.els?.arrow?.exists) {
      this.listeners.add(this, 'click', this.handleClick)
    }
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [setInitialised(), addWheelControls('horizontal'), autoPlay(3000)],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  handleClick (event) {
    const arrowEl = event.target.closest(this.els.arrow.selector)
    if (!arrowEl) return

    if (arrowEl.dataset?.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

if (!customElements.get('hover-carousel')) {
  customElements.define('hover-carousel', HoverCarousel)
}
